/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import { createContext, Component } from '@wordpress/element';

const UserContext = createContext();

class UserProvider extends Component {
    state = {
        classTier: 'Middle',
        currentAttribute: 2,
        classData: [
            {
                class: 'Lower',
                legend: 'lower-class-legend',
                legendColors: ['>30%', '25 to 30', '<25', 'No data'],
                title: 'Share of adults in the lower-income tier in 2014',
                text:
                    'The share of adults in the <span id="low_dy">lower-income</span> tier was highest in Laredo, TX and Brownsville-Harlingen, TX (47%) and lowest in Wausau, WI, Sheboygan, WI and Barnstable Town, MA (18%).',
                static_maps:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_LOWER.png',
                //static_chart:
                    //'//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Lower.svg',
                static_chart_png:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Lower.png',
            },
            {
                class: 'Middle',
                legend: 'middle-class-legend',
                legendColors: ['>55%', '50 to 55', '<50', 'No data'],
                title: 'Share of adults in the middle-income tier in 2014',
                dynamic_text:
                    "The share of adults in the <span id='mid_dy'>middle-income</span> tier was highest in Wausau, WI (67%) and lowest in Monroe, LA (42%). Middle-income adults lacked a majority in 50 metropolitan areas.<br>",
                static_maps:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_MIDDLE.png',
                //static_chart:
                    //'//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Middle_320px.svg',
                static_chart_png:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Middle-1.png',
            },
            {
                class: 'Upper',
                legend: 'upper-class-legend',
                legendColors: ['>20%', '15 to 20', '<15', 'No data'],
                title: 'Share of adults in the upper-income tier in 2014',
                dynamic_text:
                    "The share of adults in the <span id='up_dy'>upper-income</span> tier was highest in Midland, TX (37%) and lowest in Laredo, TX, McAllen-Edinburg-Mission, TX, Las Cruces, NM and Visalia-Porterville, CA (9%).",
                static_maps:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/ST_16.03.18_MiddleIncome_MetroAreaStaticMaps_UPPER.png',
                //static_chart:
                    //'//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Upper.svg',
                static_chart_png:
                    '//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Upper.png',
            },
        ],
        selectedClassData: '',
    };

    componentDidMount() {
        const selectedClassData = this.state.classData[1];
        this.setState({ selectedClassData });
        console.log(selectedClassData);
    }

    updateClass = classTier => {
        this.setState({ classTier });
        this.state.classData.map(data => {
            if (data.class === classTier) {
                this.setState({ selectedClassData: data });
            }
        });
        if ('Lower' === classTier) {
            this.setState({ currentAttribute: 1 });
        }
        if ('Middle' === classTier) {
            this.setState({ currentAttribute: 2 });
        }
        if ('Upper' === classTier) {
            this.setState({ currentAttribute: 3 });
        }
    };

    render() {
        const { children } = this.props;
        const { updateClass } = this;

        return (
            <UserContext.Provider
                value={{
                    ...this.state,
                    updateClass,
                }}
            >
                {children}
            </UserContext.Provider>
        );
    }
}

export default UserContext;

export { UserProvider };
